<script module>
  import { resolve } from '$app/paths'

  export const meta = {
    title: 'For individuals',
    teaser:
      'This help page breaks down Pausly Plus subscription details, covering everything\nfrom setting up your subscription, options for cancellation, switching between\nbilling periods, and the arrangement regarding free trials.',
    sort: 1,
  }
</script>

<p>
  For full details of our pricing and features, including how to tailor your
  experience with flexible monthly or annual payment plans, take a moment to
  visit our <a href={resolve('/pricing')}>pricing page</a>.
</p>
<h2>Getting Started is a Breeze</h2>
<p>
  To embark on your Pausly Plus journey, simply navigate to the
  <a href={resolve('/settings/billing')}>billing section in your settings</a> to initiate
  your subscription. Lean back and relax; your subscription will seamlessly renew
  itself at the commencement of your next billing cycle, ensuring an uninterrupted
  experience.
</p>
<h2>Freedom to Cancel</h2>
<p>
  Change of heart? No worries! You have the freedom to cancel your subscription
  whenever you wish. Rest assured, your Pausly Plus benefits will remain
  available in your account until the end of the current billing period, giving
  you ample time to bid farewell.
</p>
<h2>Switching Billing Periods</h2>
<p>
  Whether you're someone who likes to plan yearly or prefers the flexibility of
  monthly payments, we've got you covered. You can switch between a monthly and
  annual billing period whenever you desire. This change will take effect at the
  beginning of your next billing cycle, allowing you to tailor your subscription
  to fit your needs perfectly.
</p>
<h2>Free Trial</h2>
<p>
  Want to try before you commit? Pausly Plus comes with a 30-day free trial, so
  you can explore everything it has to offer with no strings attached. And even
  after the trial, our free tier still provides a generous glimpse into the
  service.
</p>
